import React from "react";
import PropTypes from "prop-types";

const Card = ({
    title,
    image,
    link,
    linkLabel
}) => (
    <a className="EventCard Pittcon" href={`/events/${link}`}>
        <div className="EventCardImage">
            <img src={image} alt={title} />
        </div>
        <div className="EventCardBody">
            <h3 className="EventCardTitle">{title}</h3>
            <div className="EventCardInfo">
                <a className="btn btn-outline-lx btn-block" href={`/events/${link}`}>{linkLabel}</a>
            </div>
        </div>
    </a>
);

Card.defaultProps = {
    linkLabel: "View Details"
};

Card.propTypes = {
    title: PropTypes.string,
    image: PropTypes.string,
    link: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    linkLabel: PropTypes.string
};

export default Card;